module.exports = __webpack_public_path__ + "img/2c2a5dc61de30babc08fb5e796cf1673.c0d71daa.svg";